@import '../../../globals/main.scss';

pn-address-autofill {
  display: flex;
  flex-direction: column;
  width: 50rem;

  pn-input {
    width: 50%;
  }

  .input-container-row {
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .label-container {
    color: $gray700;
    font-size: 0.875em;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .autocomplete-items {
    position: absolute;
    border-radius: 0.8rem;
    border: 0.1rem solid $gray700;
    width: 100%;
    max-height: 30rem;
    overflow-y: auto;

    &:hover,
    :focus {
      border: 0.1rem solid $blue400;
    }

    div {
      padding: 1.6rem;
      cursor: pointer;
      background-color: #fff;
      border: 0.1rem solid transparent;

      &:first-child {
        border-radius: 0.8rem 0.8rem 0 0;
      }

      &:last-child {
        border-radius: 0 0 0.8rem 0.8rem;
      }

      &:hover {
        background-color: #e0f8ff;
      }
    }

    .autocomplete-active {
      background-color: #e0f8ff;
    }
  }

  .autocomplete-items:empty {
    display: none;
  }

  pn-input {
    max-width: 25rem;
    width: 100%;
  }
}